//
// ███████╗████████╗ █████╗ ████████╗███████╗
// ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
// ███████╗   ██║   ███████║   ██║   █████╗
// ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
// ███████║   ██║   ██║  ██║   ██║   ███████╗
// ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
//
const state = {
  tags: [],
  tickets: [],
  showNewTicketForm: false,
  supportTicketDetail: {
    data: {},
    id: 0,
    details: false,
    dirty: false,
    inProgress: false
  },
  supportTicketDetailId: 0,
  showDetailPage: false

}

//
//  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
// ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
// ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
// ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
// ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
//  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
//
const getters = {

}

//
// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const mutations = {

  showSupportNewTicketForm (state) {
    state.showNewTicketForm = true
  },

  closeSupportNewTicketForm (state) {
    state.showNewTicketForm = false
  },

  showSupportDetailPage (state) {
    state.showDetailPage = true
  },

  closeSupportDetailPage (state) {
    state.showDetailPage = false
  },

  setSupportTicketDetail (state, payload) {
    // Get the id
    const id = parseInt(payload)

    state.supportTicketDetailId = id

    // Get the index where we have saved data within the tickets array
    const idx = state.tickets.findIndex((elm) => {
      return elm.id === id
    })

    state.supportTicketDetail.data = state.tickets[idx]
  },

  updateTags (state, payload) {
    const data = payload.data
    state.tags = []

    data.forEach((element) => {
      state.tags.push(element)
    })
  },

  updateTickets (state, payload) {
    state.tickets = payload.data
  }
}

//
//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const actions = {

  /**
     * Get the tags
     *
     * @param commit
     * @param state
     *
     * @returns {Promise<any>}
     */
  getTags ({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/support/tags').then(
        response => {
          let result = {
            'data': response.data.data
          }
          commit('updateTags', result)
          resolve(result)
        }
      )
    })
  },

  /**
     * Get the tickets for the current user
     *
     * @param commit
     * @param state
     *
     * @returns {Promise<any>}
     */
  getTickets ({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/support/tickets').then(
        response => {
          let result = {
            'data': response.data.data
          }
          commit('updateTickets', result)
          resolve(result)
        }
      )
    })
  },

  /**
     * Create a new support Ticket
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param payload
     *
     * @returns {Promise<any>}
     */
  create ({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/support/ticket', payload)
        .then(response => {
          this._vm.$snotify.success('Ticket created successfully')
          dispatch('getTickets')
          resolve(true)
        }
        ).catch(() => {
          this._vm.$snotify.error('Error while creating Ticket, please try again')
        }
        )
    })
  },

  reply ({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/support/ticket/addreply', payload)
        .then(response => {
          this._vm.$snotify.success('Ticket reply successfully')
          dispatch('getTickets')
          commit('setSupportTicketDetail', state.supportTicketDetailId)
          resolve(true)
        }
        ).catch(() => {
          this._vm.$snotify.error('Error while replying to Ticket, please try again')
        }
        )
    })
  }

}

//
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝
//
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
